import { getDataAsync } from "./PortalApi";
import Invoice from "interfaces/response/Invoice";
import PaymentCard from "interfaces/response/PaymentCard";

export const getInvoicesAsync = (subscriptionId: number) => {
  const url = `Subscription/${subscriptionId}/Invoices?excludeStatusParameter=draft`;
  return getDataAsync<Invoice[]>(url);
};

export const getUserDefaultPaymentCardDetail = () => {
  const url = `Users/Cards/Default`;
  return getDataAsync<PaymentCard>(url);
};
